import { create } from 'zustand';

const useLoginFormStore = create((set) => ({
  username: '',
  password: '',
  error: null,
  showPassword: false,
  setUsername: (username) => set({ username }),
  setPassword: (password) => set({ password }),
  setError: (error) => set({ error }),
  toggleShowPassword: () => set((state) => ({ showPassword: !state.showPassword })),
  reset: () => set({ username: '', password: '', error: null, showPassword: false }),
}));

export default useLoginFormStore;
